import Store from 'store/store';
import { shouldShowShowtimes } from 'utils/bolt';
export * from 'utils/bolt/index.js';

export const isDualViewEnabled = pages => {
	const appData = Store.get().appData;

	if (!appData?.options?.dualView) {
		return false;
	}

	if (!pages) {
		pages = Object.values(appData.pages);
	}
	const activePage = Store.get().activePage.replace(/-(showtimes|homeEnt|stickAndScaleWidget)$/, '');

	const hasShowtimes = pages.find(page => page.id === `${activePage}-showtimes`);
	const hasHomeEnt = pages.find(page => page.id === `${activePage}-homeEnt`);
	const hasWidget = pages.find(page => page.id === 'stickAndScaleWidget');

	return (hasShowtimes && shouldShowShowtimes() && hasHomeEnt) || (hasShowtimes && hasHomeEnt && hasWidget);
};